import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {FormattedHTMLMessage, FormattedMessage} from 'react-intl';
import {
  baseStyles,
  BORDER_RADIUS,
  FIELD_SPACE,
  FIELD_SPACE_XS,
  FORM_MAX_WIDTH,
  withMediaQueries,
  withMultipleStyles
} from "src/styles/Styles";
import {FormControl, Typography} from "@material-ui/core";
import View from "src/js/components/commons/View";
import {FontWeightMedium} from "src/res/FontWeight";
import Space from "src/js/components/commons/Space";
import {GetActionButton, GetImageActionButton} from "src/js/utils/ActivityHelper";
import {SpaceNormal} from "src/res/Spacing";
import {
  ColorFieldBorderHover,
  ColorFieldBorderSelected,
  ColorNegative,
  ColorSubTitle,
  ColorTheme,
  ColorTitle,
  ColorWhite
} from "src/styles/Colors";
import TextView from "src/js/components/commons/TextView";
import FormHelperText from "@material-ui/core/FormHelperText";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import InputLabel from "@material-ui/core/InputLabel";
import RadioButtonUncheckedIcon from "@material-ui/icons/RadioButtonUnchecked";
import RadioButtonCheckedIcon from "@material-ui/icons/RadioButtonChecked";
import ButtonBase from "@material-ui/core/ButtonBase";
import DateTimeHelper from "src/js/utils/DateTimeHelper";
import FileHelper from "src/js/utils/FileHelper";
import {doJoinInline, doJoinInlineComplete, resetLoginErrMsg} from "src/js/actions/loginActions";
import {GameTextField} from "src/js/components/commons/GameTextField";
import {isEmailValid} from "src/js/utils/ApiHelper";
import tinycolor from "tinycolor2";
import DialogView from "src/js/components/commons/DialogView";
import {locString} from "src/js/components/commons/ViewHelper";
import {getRedirectSearch, PathJoin} from "src/js/components/routes/NavHelper";
import FieldSpace from "src/js/components/commons/FieldSpace";

const useStyles = () => ({
  viewGenderWrapper: {
    minHeight: 50,
    position: 'relative',
    display: 'flex',
    flex: 1,
    width: '100%',
    flexDirection: 'row',
    borderRadius: BORDER_RADIUS,
    // backgroundColor: ColorFieldBgWhite,
    // border: '1px solid '+ ColorFieldBorder,
  },
  viewGenderWrapperError: {
    minHeight: 50,
    position: 'relative',
    display: 'flex',
    flex: 1,
    width: '100%',
    flexDirection: 'row',
    borderRadius: BORDER_RADIUS,
    // backgroundColor: ColorFieldBgWhite,
    border: '1px solid '+ ColorNegative,
  },
  viewGender: {
    minHeight: 50,
    position: 'relative',
    display: 'flex',
    flex: 1,
    width: '100%',
    flexDirection: 'row',
    borderRadius: BORDER_RADIUS,
    padding: 8,
    // backgroundColor: ColorFieldBgWhite,
    border: '1px solid '+ ColorFieldBorderHover,
    // '&:hover': {
    //   backgroundColor: ColorFieldHover,
    //   border: '1px solid '+ ColorFieldBorderHover,
    // },
  },
  viewGenderSelected: {
    minHeight: 50,
    position: 'relative',
    display: 'flex',
    flex: 1,
    width: '100%',
    flexDirection: 'row',
    borderRadius: BORDER_RADIUS,
    padding: 8,
    border: '2px solid '+ ColorFieldBorderSelected,
    backgroundColor: ColorWhite,
  }
});

const GENDERS_DATA = [
  {id: 1, nameId: 'male'},
  {id: 2, nameId: 'female'},
];

class JoinNow extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      mobileNumber: '',
      emailExists: false,
      email: '',
      name: '',
      age: 0,
      gender: '',
      nationality: '',
      imageUrl: null,
      imageFiles: null,
    };

    this.initialFiles = [];

    this.ageData = [];
    for (let i = 16; i <= 64; i++) {
      this.ageData.push({id: i, name: ''+ i});
    }
    this.ageData.push({id: 65, name: '64+'});
  }

  componentDidMount() {
    // const {fetchNationalities} = this.props;
    // fetchNationalities();
  }

  render() {
    const {classes, title, subTitle, uiConfigs, maxWidth, isXS, isLTR, showNegativeAction, noMinHeight, needContactNumber, contactNumberHelperTextId} = this.props;
    const {email, name, gender, age, nationality, mobileNumber, showValidationMsg, errorMsg} = this.state;

    uiConfigs.overlayTitleColor = ColorTitle;
    uiConfigs.overlaySubTitleColor = ColorSubTitle;
    uiConfigs.overlayBgColor = ColorWhite;
    uiConfigs.actionBgColor = ColorTheme;
    uiConfigs.actionTitleColor = ColorWhite;

    let emailError = null;
    let nameError = null;
    let genderError = null;
    let ageError = null;
    let nationalityError = null;
    let mobileNumberError = null;
    if (showValidationMsg) {
      if (!email || !isEmailValid(email)) {
        emailError = <FormattedMessage id='validation.enterEmail' />;
      }
      if (!name || name.trim().length < 2) {
        nameError = <FormattedMessage id='validation.enterName' />;
      }
      if (!gender) {
        genderError = <FormattedMessage id='validation.selectGender' />;
      }
      if (!age) {
        ageError = <FormattedMessage id='validation.selectAge' />;
      }
      // if (!nationality) {
      //   nationalityError = <FormattedMessage id='validation.selectNationality' />;
      // }
      if (!mobileNumber || mobileNumber.trim().length === 0) {
        mobileNumberError = <FormattedMessage id='activity.validationMobileRequired' />;
      }
    }

    const inputSpace = isXS ? FIELD_SPACE_XS : FIELD_SPACE;
    const closeActionStyle = {position: 'absolute', top: 8};
    if (isLTR) {
      closeActionStyle.left = 8;
    } else {
      closeActionStyle.right = 8;
    }
    return (
      <div className={classes.viewColumnFullWidth} style={{minHeight: noMinHeight ? 0 : 550, marginBottom: 6}}>
        {title || subTitle ?
          <div className={classes.viewColumnFullWidth} style={{justifyContent: 'center', margin: 16, marginBottom: 8}}>
            <Typography style={{fontWeight: FontWeightMedium, color: uiConfigs.overlayTitleColor, marginBottom: 4}} variant={isXS ? "h6" : "h5"}>
              {title}
            </Typography>
            <TextView variant={isXS ? "caption" : "body2"} align={'center'} color={uiConfigs.overlaySubTitleColor}>
              {subTitle}
            </TextView>
          </div>
          : null
        }

        <form className={classes.viewColumnFullWidth} onKeyDown={this.handleKeyPress} style={{marginTop: 24, maxWidth: FORM_MAX_WIDTH, minWidth: Math.min(window.appWidth - 56, FORM_MAX_WIDTH)}}>
          {/*<div className={classes.viewRowFullWidth}>*/}
          {/*  <TextView variant={locationMessageVariant} fontWeight={FontWeightRegular} color={locationMessageColor} textAlign={'left'} style={{marginBottom: inputSpace, marginTop: isXS ? -12 : 0}}>*/}
          {/*    {<FormattedMessage id={locationMessageId} />}*/}
          {/*  </TextView>*/}
          {/*</div>*/}

          {/*<div className={classes.viewColumnFullWidthNoCenter1}>*/}
          {/*  <MediaPlaceholder labelId={'profile.image'} />*/}
          {/*  <SingleFilePicker*/}
          {/*    required={false}*/}
          {/*    filesLimit={1}*/}
          {/*    isInBgWhite={true}*/}
          {/*    showPreviewsInDropzone={true}*/}
          {/*    acceptedFiles={ACCEPTED_IMAGE_MIMES}*/}
          {/*    maxFileSize={IMAGE_MAX_SIZE}*/}
          {/*    maxWidthOrHeight={IMAGE_PROFILE_MAX_WIDTH_HEIGHT}*/}
          {/*    aspectRatio={1}*/}
          {/*    size={'small'}*/}
          {/*    initialFiles={null}*/}
          {/*    onChange={(files) => {*/}
          {/*      this.onChangeFiles(files, 'imageUrl');*/}
          {/*    }}*/}
          {/*    onDelete={(file) => {*/}
          {/*      this.onDeleteFile(file, 'imageUrl');*/}
          {/*    }}*/}
          {/*  />*/}
          {/*</div>*/}
          {/*<FieldSpace/>*/}

          <GameTextField
            color={uiConfigs.overlayTitleColor}
            bgColor={uiConfigs.overlayBgColor}
            variant="filled"
            fullWidth
            size="small"
            type="email"
            id="email"
            name="email"
            autoComplete="text"
            label={<FormattedMessage id='login.email'/>}
            inputProps={{maxLength: 255}}
            value={email}
            onChange={this.onChange}
            error={emailError != null}
            helperText={emailError}
          />
          <Space horizontal={inputSpace}/>

          <GameTextField
            color={uiConfigs.overlayTitleColor}
            bgColor={uiConfigs.overlayBgColor}
            variant="filled"
            fullWidth
            size="small"
            type="name"
            id="name"
            name="name"
            autoComplete="text"
            label={<FormattedMessage id='login.name'/>}
            inputProps={{maxLength: 200}}
            value={name}
            onChange={this.onChange}
            error={nameError != null}
            helperText={nameError}
          />
          <Space horizontal={inputSpace}/>

          {/*<div className={classes.viewGenderWrapper}>*/}
          {/*  {GENDERS_DATA.map((item, index) => {*/}
          {/*    const isSelected = item.id === gender;*/}
          {/*    let styles = null;*/}
          {/*    if (index === 0) {*/}
          {/*      styles = {marginLeft: this.props.isLTR ? 0 : 8, marginRight: this.props.isLTR ? 8 : 0}*/}
          {/*    }*/}
          {/*    const onClick = () => {*/}
          {/*      this.onChangeGender(item);*/}
          {/*    }*/}
          {/*    return (*/}
          {/*      <div className={classes.flexColumn} style={styles}>*/}
          {/*        <ButtonBase*/}
          {/*          className={isSelected ? classes.viewGenderSelected : classes.viewGender}*/}
          {/*          style={{*/}
          {/*            backgroundColor: tinycolor(uiConfigs.overlayTitleColor).setAlpha(isSelected ? 0.2 : 0.1),*/}
          {/*            borderColor: tinycolor(uiConfigs.overlayTitleColor).setAlpha(isSelected ? 0.8 : 0.6),*/}
          {/*          }}*/}
          {/*          onClick={onClick}>*/}
          {/*          <div className={classes.flexRow}>*/}
          {/*            {isSelected ?*/}
          {/*              <RadioButtonCheckedIcon style={{color: uiConfigs.overlayTitleColor}}/>*/}
          {/*              : <RadioButtonUncheckedIcon style={{color: tinycolor(uiConfigs.overlayTitleColor).setAlpha(0.6)}}/>*/}
          {/*            }*/}
          {/*            <Space verticalSpace={1}/>*/}
          {/*            <div className={classes.flexColumnNoCenter}>*/}
          {/*              <Typography variant="subtitle1" color="textPrimary" className={isSelected ? classes.typoBold : classes.typoNormal} align={'left'} style={{color: tinycolor(uiConfigs.overlayTitleColor).setAlpha(isSelected ? 1 : 0.8)}}>*/}
          {/*                <FormattedMessage id={item.nameId} />*/}
          {/*              </Typography>*/}
          {/*            </div>*/}
          {/*          </div>*/}
          {/*        </ButtonBase>*/}
          {/*      </div>*/}
          {/*    )*/}
          {/*  })}*/}
          {/*</div>*/}
          {/*{genderError ? <FormHelperText className={classes.helperErrorPadding}>{genderError}</FormHelperText> : null}*/}
          {/*<Space horizontal={inputSpace}/>*/}

          {/*<FormControl*/}
          {/*  onMouseEnter={this.handleMouseEnter}*/}
          {/*  onMouseLeave={this.handleMouseLeave}*/}
          {/*  onFocus={this.handleFocus}*/}
          {/*  onBlur={this.handleBlur}*/}
          {/*  error={ageError != null}*/}
          {/*  size="small"*/}
          {/*  fullWidth*/}
          {/*  variant="filled">*/}
          {/*  <InputLabel id="dropDown" style={{color: tinycolor(uiConfigs.overlayTitleColor).setAlpha(this.state.isFocused ? 1 : this.state.isHovered ? 0.9 : 0.8)}}><FormattedMessage id={'login.age'} /></InputLabel>*/}
          {/*  <Select*/}
          {/*    labelId="dropDown"*/}
          {/*    required*/}
          {/*    id="age"*/}
          {/*    name="age"*/}
          {/*    value={age}*/}
          {/*    disableUnderline={true}*/}
          {/*    className={classes.textFieldBgWhite}*/}
          {/*    style={{*/}
          {/*      backgroundColor: tinycolor(uiConfigs.overlayTitleColor).setAlpha(this.state.isFocused ? 0.2 : 0.1),*/}
          {/*      borderColor: tinycolor(uiConfigs.overlayTitleColor).setAlpha(this.state.isFocused ? 1 : this.state.isHovered ? 0.8 : 0.6),*/}
          {/*      borderStyle: 'solid',*/}
          {/*      borderWidth: 1,*/}
          {/*      color: uiConfigs.overlayTitleColor,*/}
          {/*    }}*/}
          {/*    onChange={this.onChange}>*/}
          {/*    {this.ageData.map((type) => {*/}
          {/*      return (*/}
          {/*        <MenuItem key={type.id} value={type.id}>{type.name}</MenuItem>*/}
          {/*      )*/}
          {/*    })}*/}
          {/*  </Select>*/}
          {/*  {ageError ? <FormHelperText className={classes.helperError}>{ageError}</FormHelperText> : null}*/}
          {/*</FormControl>*/}
          {/*<Space horizontal={inputSpace}/>*/}

          {/*<FormControl*/}
          {/*  error={nationalityError != null}*/}
          {/*  size="small"*/}
          {/*  fullWidth*/}
          {/*  variant="filled">*/}
          {/*  <InputLabel id="dropDown"><FormattedMessage id={'nationality'} /></InputLabel>*/}
          {/*  <Select*/}
          {/*    labelId="dropDown"*/}
          {/*    required*/}
          {/*    id="nationality"*/}
          {/*    name="nationality"*/}
          {/*    value={nationality}*/}
          {/*    disableUnderline={true}*/}
          {/*    className={classes.textFieldBgWhite}*/}
          {/*    onChange={this.onChange}>*/}
          {/*    {map(activities.nationalities, (type) => {*/}
          {/*      return (*/}
          {/*        <MenuItem key={type.id} value={type.id}>{type.name}</MenuItem>*/}
          {/*      )*/}
          {/*    })}*/}
          {/*  </Select>*/}
          {/*  {nationalityError ? <FormHelperText className={classes.helperError}>{nationalityError}</FormHelperText> : null}*/}
          {/*</FormControl>*/}
          {/*<Space horizontal={inputSpace}/>*/}

          {needContactNumber ?
            <React.Fragment>
              <GameTextField
                color={uiConfigs.overlayTitleColor}
                bgColor={uiConfigs.overlayBgColor}
                variant="filled"
                fullWidth
                size="small"
                id="mobileNumber"
                name="mobileNumber"
                autoComplete="text"
                label={<FormattedMessage id='activity.mobileNumberWithCode'/>}
                inputProps={{maxLength: 16}}
                value={mobileNumber}
                onChange={this.onChange}
                error={mobileNumberError != null}
                helperText={mobileNumberError ? mobileNumberError : contactNumberHelperTextId ? <FormattedMessage id={contactNumberHelperTextId}/> : null}
              />
              <FieldSpace multiplier={1}/>
            </React.Fragment>
            : null
          }

          <View className={classes.viewRowFullWidth} style={{justifyContent: 'center'}}>
            {/*{showNegativeAction ?*/}
            {/*  <React.Fragment>*/}
            {/*    {this.actionButton(<FormattedMessage id={'play.joinRab7MaybeLater'} />, this.cancelPost, true)}*/}
            {/*    <FieldSpace vertical={true}/>*/}
            {/*  </React.Fragment>*/}
            {/*  : null*/}
            {/*}*/}
            {showNegativeAction ? this.actionButton(<FormattedMessage id={'generic.cancel'} />, this.cancelPost, true, {height: 48, flex: 1, marginRight: isLTR ? 16 : 0, marginLeft: isLTR ? 0 : 16}) : null}
            {this.actionButton(<FormattedMessage id={'manage.confirm'} />, this.onSubmitClicked, false, {height: 48, flex: 1})}
          </View>

          {this.renderErrorMessage()}
        </form>

        {this.renderDialogView()}

        {/*{showNegativeAction ?*/}
        {/*  <div style={closeActionStyle}>*/}
        {/*    <IconButton*/}
        {/*      size={'medium'}*/}
        {/*      onClick={this.cancelPost}*/}
        {/*      style={{width: 46, height: 46}}>*/}
        {/*      <AppIcon icon={IconCross} />*/}
        {/*    </IconButton>*/}
        {/*  </div>*/}
        {/*  : null*/}
        {/*}*/}
      </div>
    );
  }

  renderDialogView() {
    const {classes} = this.props;
    const {showDialog, dialogInfo} = this.state;
    if (!showDialog) {
      return null;
    }

    return (
      <DialogView
        classes={classes}
        show={showDialog}
        {...dialogInfo}
      />
    );
  }

  showDialog(dialogInfo) {
    if (dialogInfo) {
      this.setState({showDialog: true, dialogInfo: dialogInfo});
    }
  }

  hideDialog(onDone) {
    this.setState({showDialog: false, dialogInfo: null}, onDone);
  }

  handleKeyPress = (e) => {
    if (e.keyCode === 13) {
      this.onSubmitClicked();
    }
  }

  handleMouseEnter = () => {
    this.setState({isHovered: true});
  }
  handleMouseLeave = () => {
    this.setState({isHovered: false});
  }
  handleFocus = () => {
    this.setState({isFocused: true});
  }
  handleBlur = () => {
    this.setState({isFocused: false});
  }

  renderErrorMessage() {
    const {classes, isXS, login} = this.props;
    const {emailExists} = this.state;

    let errMsg = null
    if (login && login.errMsg) {
      errMsg = login.errMsg;
    }

    const inputSpace = isXS ? FIELD_SPACE_XS : FIELD_SPACE;
    return errMsg && (
      <div className={classes.viewColumnFullWidth}>
        <Space top={inputSpace}/>
        <div className={classes.viewColumnFullWidth}>
          <Typography align={"center"} variant={isXS ? "body2" : "body1"} style={{color: ColorNegative, fontWeight: FontWeightMedium}}>
            <FormattedMessage id={errMsg} />
          </Typography>
        </div>
        <Space bottom={inputSpace/2}/>

        {emailExists ? this.actionButton(<FormattedMessage id={'login.loginHere'} />, this.onLoginHereClicked, false) : null}
      </div>
    );
  }

  actionButton = (title, onClick, isNegative, style) => {
    const {uiConfigs, maxWidth, isXS} = this.props;
    const sizeFactor = uiConfigs.sizeFactor;
    let buttonWidth = (maxWidth - 2 * uiConfigs.infoViewContentHorizontalMargin * sizeFactor - (!isXS ? 2 * SpaceNormal : 0) - (isXS ? FIELD_SPACE_XS : FIELD_SPACE)) / 2;
    buttonWidth = Math.max(150, buttonWidth) / sizeFactor;
    if (uiConfigs.otherActionImage) {
      return (
        <GetImageActionButton
          uiConfigs={uiConfigs}
          sizeFactor={sizeFactor}
          onClick={onClick}
          title={title}
          width={buttonWidth}
        />
      );
    } else {
      return (
        <GetActionButton
          isNegative={isNegative}
          uiConfigs={uiConfigs}
          onClick={onClick}
          title={title}
          size={'large'}
          style={style}
        />
      );
    }
  };

  onLoginHereClicked = () => {
    if (this.props.onDone) {
      this.props.onDone(-1);
    }
    this.updateState({emailExists: false});
    this.props.history.push({
      pathname: PathJoin,
      search: getRedirectSearch(this.props.history.location, {se: this.props.showEnd ? 1 : 2})
    });
  }

  updateState(state) {
    state.showValidationMsg = false;
    state.emailExists = false;
    this.setState(state);
    if (this.props.login.errMsg) {
      this.props.resetLoginErrMsg();
    }
  }

  onChangeGender = (gender) => {
    this.updateState({gender: gender.id});
  };

  onChange = (event) => {
    const value = event.target.value;
    this.updateState({[event.target.name]: value});
  };

  onChangeFiles(files, id) {
    const {
      imageUrl
    } = this.state;

    let eImageUrl = null;
    let keyImageUrl = null;
    let keyImageFiles = null;
    if (id === 'imageUrl') {
      eImageUrl = imageUrl;
      keyImageUrl = 'imageUrl';
      keyImageFiles = 'imageFiles';
    }

    let lFiles = null;
    let lFileUrl = null;
    if (files && files.length > 0) {
      files.forEach((file) => {
        if (FileHelper.isFileNameSame(file, eImageUrl)) {
          lFileUrl = eImageUrl;
        } else {
          if (!lFiles) {
            lFiles = [];
          }
          lFiles.push(file);
        }
      });
    }

    this.setState({showValidationMsg: false, [keyImageUrl]: lFileUrl, [keyImageFiles]: lFiles});
  }

  onDeleteFile(file, id) {
    const {
      imageUrl,
      imageFiles,
    } = this.state;

    let eImageUrl = null;
    let eImageFiles = null;
    let keyImageUrl = null;
    let keyImageFiles = null;
    let keyIsImageDeleted = null;
    if (id === 'imageUrl') {
      eImageUrl = imageUrl;
      eImageFiles = imageFiles;
      keyImageUrl = 'imageUrl';
      keyImageFiles = 'imageFiles';
      keyIsImageDeleted = 'isImageDeleted';
    }

    let lFiles = [];
    let lFileUrl = eImageUrl;
    if (eImageFiles) {
      eImageFiles.forEach(lFile => {
        if (FileHelper.areFilesSame(lFile, file)) {
          lFiles.push(lFile);
        }
      });
      lFiles = eImageFiles.filter(x => !lFiles.includes(x));
    }
    if (FileHelper.isFileNameSame(file, eImageUrl)) {
      lFileUrl = null;
    }

    this.setState({showValidationMsg: false, [keyImageUrl]: lFileUrl, [keyImageFiles]: lFiles, [keyIsImageDeleted]: true});
  }

  cancelPost = () => {
    if (this.props.onDone) {
      this.props.onDone();
    }
  };

  onSubmitClicked = () => {
    const {activityId, activityPostId, needContactNumber, onDone} = this.props;
    const {email, name, gender, age, nationality, mobileNumber, imageFiles} = this.state;
    if (!email || !isEmailValid(email)
      || !name || name.trim().length < 2
      // || !gender || !age || !nationality
      || (needContactNumber && (!mobileNumber || mobileNumber.trim().length === 0))) {
      this.setState({showValidationMsg: true});
      return;
    }

    const data = {
      activityId: this.props.activityId,
      rewardId: this.props.rewardId,
      email: email,
      name: name,
      // gender: gender,
      // birthday: DateTimeHelper.getApiDateOnlyStringFromDate(DateTimeHelper.getDateBeforeYearsFromNow(age)),
      // nationality: nationality,
      contactMobileNumber: mobileNumber,
    }
    // if (imageFiles && imageFiles.length > 0) {
    //   data['imageFile'] = imageFiles[0].file;
    // }

    const onSuccess = (response) => {
      // let onDialogDone = () => {
        this.props.doJoinInlineComplete(response.data);
        if (onDone) {
          onDone(1);
        }
      //   onDialogDone = null;
      // }

      // this.showDialog({
      //   title: locString('login.welcome'),
      //   message: <FormattedHTMLMessage id={'login.joined'} values={{value: response.data.user.rab7Number}}/>,
      //   positiveText: locString('ok'),
      //   onPositiveClicked: () => {
      //     this.hideDialog(onDialogDone);
      //   },
      //   onClose: onDialogDone
      // });
    };
    const onError = (response) => {
      this.setState({emailExists: response.data.emailExists});
    }
    this.props.doJoinInline(data).then(onSuccess).catch(onError);
  };

}

JoinNow.propTypes = {
  classes: PropTypes.object,
  onDone: PropTypes.func,
};

JoinNow.contextTypes = {
  intl:PropTypes.object.isRequired
}

function mapStateToProps(state) {
  return {
    user: state.admin.user,
    login: state.login
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    doJoinInline: (data) => dispatch(doJoinInline(data)),
    doJoinInlineComplete: (data) => dispatch(doJoinInlineComplete(data)),
    resetLoginErrMsg: () => dispatch(resetLoginErrMsg()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withMultipleStyles(baseStyles, useStyles)(withMediaQueries([
  ['isXS', theme => theme.breakpoints.down('xs'), {defaultMatches: true}],
])(JoinNow)));
